import React from "react";
import styled from "styled-components";
import { Typography } from "@mui/material";

const MainContainer = styled.div`
  border: 1px solid #003e85;
  box-sizing: border-box;
  border-radius: 4px;
  padding: 20px 20px 10px;
  position: relative;
  margin-top: 20px;
  .labelText {
    position: absolute;
    top: -12px;
    left: 8px;
    background: white;
    padding: 0px 6px;
  }
`;

const ContainerBox = ({ label, children }) => {
  return (
    <MainContainer>
      <Typography className="labelText" variant="subtitle2" color={"#003E85"}>
        {label}
      </Typography>
      {children}
    </MainContainer>
  );
};

export default ContainerBox;
